import React, {useMemo} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';

const fallbackValue = [];

const Checkboxes = ({label, name, help, onChange, options, disabled, validators, footer, noItems}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    let value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const groups = useMemo(() => {
        const gs = [];
        options.forEach(o => {
            if (o.group && !gs.includes(o.group)) {
                gs.push(o.group);
            }
        });
        return gs;
    }, [options]);

    const handleChange = (state) => {
        updateField(name, state);
        onChange && onChange(state);
    }

    const toggle = (e) => {
        let val = Array.isArray(value) ? value : [];

        const index = val.indexOf(e);
        if (index > -1) {
            val = val.filter((v, i) => i !== index);
        } else {
            val = [...val, e];
        }

        handleChange(val);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled, footer}}>

        <fieldset>
            <legend className="sr-only">{label}</legend>
            <div className="space-y-3 mt-2 overflow-y-auto max-h-[25vh]">
                {(groups.length === 0 && options.length === 0) &&
                    <p className="mb-2 text-muted text-center">{noItems ?? 'No items available'}</p>
                }

                {groups.length < 2 && <Group title={null} {...{options, name, value, isDisabled, toggle}} />}
                {groups.length >= 2 && <>
                    {groups.sort().map((group, index) => {
                        return <div key={group+index} className="space-y-3">
                            <div className="text-sm font-bold text-brand">{group}</div>
                            <Group title={group}
                                options={options.filter(o => o.group === group)}
                                {...{name, value, isDisabled, toggle}}
                            />
                        </div>
                    })}
                </>}
            </div>
        </fieldset>

    </CommonFieldWrapper>
}

const Group = ({options, name, value, isDisabled, toggle}) => {
    return options.sort((a, b) => a?.label?.localeCompare(b?.label)).map((option, index) => {
        const val = typeof option === 'string' ? option : option.value;
        const label = typeof option === 'string' ? option : option.label;

        return <div className="relative flex items-start" key={label+val+index}>
            <div className="flex h-6 items-center">
                <input
                    id={'checkbox-'+name+val}
                    aria-describedby={'desc-'+name+val}
                    name={name}
                    type="checkbox"
                    className="ml-1 h-4 w-4 rounded border-gray-300 text-brand focus:ring-brand disabled:bg-gray-200"
                    checked={value && value.indexOf(val) > -1}
                    onChange={() => toggle(val)}
                    disabled={isDisabled}
                />
            </div>
            <div className="ml-3 text-sm leading-6">
                <label htmlFor={'checkbox-'+name+val} className="font-medium text-gray-900">
                    {label}
                </label>
                <p id={'desc-'+name+val} className="text-muted leading-snug">
                    {option.help}
                </p>
            </div>
        </div>
    })
}

export default Checkboxes;
